<div style="text-align:center">
    <h1>
      {{ title }}
    </h1>
  </div>
  <div class="container" style="text-align:left">
    <div class="">
    


                 <input type="checkbox" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" /> 
                
                 <strong>Select/ Unselect All</strong>


                 
            


          <br>


     
  </div>

  <div class="col-12">
    
    <div class="list-group d-flex flex-row flex-wrap">
        <li  class="w-50 list-group-item-action" *ngFor="let item of marketList" name="list_name" (change)="onItemSelect()">
          <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name" /> {{item?.item_name}}
        </li>


    </div>
  </div>
    <button class="m-1" mat-raised-button style="background-color: red;color: white;" (click)="onNoClick()">Cancel</button>
    <button class="m-1" mat-raised-button
    [ngStyle]="{'background-color': butCol}" style="color: white;"
    disabled="{{marketNotPicked}}" (click)="onOKClick()" >Save</button>

    


</div>
